import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-enroll-order-support-article',
    template: `
        <ng-container i18n="@@support.articles.enrollOrder">
            <p>After enrolling students, you can immediately purchase the necessary licenses.</p>
            <p>There are two payment options available:</p>
            <ul>
                <li><strong>Bank transfer:</strong> download the invoice and pay by bank transfer. The licenses are activated as soon as we receive the payment.</li>
                <li><strong>Pay by card:</strong> pay securely online. The licenses are activated instantly.</li>
            </ul>
            <figure>
                <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/activateLicenses.png" />
            </figure>
            <p>If you close this window without payment, the students will be enrolled without a license. You can then activate a license for them afterwards. Students may also purchase their own license.</p>
        </ng-container>
    `
})
export class EnrollOrderSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
